import { createRouter, createWebHistory } from 'vue-router'
import DashBord from '../views/DashBordView.vue'
import Login from '../views/LoginView.vue'
import UserManagement from '../views/UserManagementView.vue'
import AuthlLogs from '../views/AuthLogsView.vue'
import UseStatus from '../views/UseStatusView.vue'
import AuthSettings from '../views/AuthSettingsView.vue'
import PasswordReset from '../views/PasswordResetView.vue'
import Licenses from '../views/LicensesView.vue'
import Cognito  from '../utils/cognito.js'

const routes = [
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { title: 'ログイン', requiresAuth: false}
    },
    {
        path: '/',
        name: 'dashboard',
        component: DashBord,
        meta: { title: 'ダッシュボード', requiresAuth: true}
    },
    {
      path: '/usermanagement',
        name: 'usermanagement',
        component: UserManagement,
        meta: { title: '利用者管理', requiresAuth: true}
    },
    {
      path: '/authlogs',
        name: 'authlogs',
        component: AuthlLogs,
        meta: { title: '認証ログ確認', requiresAuth: true}
    },
    {
        path: '/authsettings',
        name: 'authsettings',
        component: AuthSettings,
        meta: { title: '認証設定', requiresAuth: true}
    },
    {
      path: '/usestatus',
        name: 'usestatus',
        component: UseStatus,
        meta: { title: '利用状況確認', requiresAuth: true}
    },
    {
        path: '/passwordreset',
        name: 'passwordreset',
        component: PasswordReset,
        meta: { title: 'パスワードリセット', requiresAuth: false}
    },
    {
        path: '/licenses',
        name: 'licenses',
        component: Licenses,
        meta: { title: 'オープンソースライセンス', requiresAuth: false}
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes, // eslint-disable-next-line
})

// 画面遷移成功後にページタイトルを設定
router.afterEach((to) => {
    if (to.meta && to.meta.title) {
        document.title = to.meta.title + ' | ProoFace'
    }
});

// 画面遷移前にCognito セッションチェック
router.beforeEach(async (to) => {
    const isLoginPage = to.name === 'login';
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);

    // ログイン画面でも認証必須画面でもなければセッション確認は不要
    if (!isLoginPage && !requiresAuth) {
        return true;
    }

    // 現在のログインセッションが有効か確認
    const isSession = await Cognito.getCognitoLoginUser();

    if (isLoginPage) {
        // ログイン画面へのアクセス時、既にログイン済みなら二重ログインさせずHOMEへ
        return isSession ? { path: '/' } : true;
    }
    // ユーザー情報なし or セッションが無効 → ログイン画面へリダイレクト
    return isSession ? true : { path: '/login' };
});
export default router